import React from 'react';
import { Dropdown } from 'semantic-ui-react';

export const TaskOptionTabs = ({ tabs, activeKind, onSelect }) => {
    const options = tabs.map(tab => ({ key: tab.kind, text: tab.label, value: tab.kind }));

    return (
        <div className="task-options-tabs">
            <Dropdown
                id="task-options-selector"
                className="task-options-select"
                selection
                options={options}
                value={activeKind}
                onChange={(e, { value }) => onSelect(value)}
                aria-label="Task option type"
            />
        </div>
    );
};
